export default "__VITE_ASSET__5bcb6ca5__"